import { useTheme } from "../context/ThemeContext";

export default function BrandLogo({ className = "h-8", showMark = false }) {
  const { theme } = useTheme();

  if (showMark) {
    const markSrc = theme === "dark" ? "/mark-dark.svg" : "/mark.svg";
    return (
      <img
        src={markSrc}
        alt="Maaly Pay"
        className={className}
        data-testid="brand-mark"
      />
    );
  }

  const src = theme === "dark" ? "/logo-dark.svg" : "/logo.svg";
  return (
    <img
      src={src}
      alt="Maaly Pay"
      className={className}
      data-testid="brand-logo"
    />
  );
}
